import { UserModel } from './UserModel';
import { WorkoutModel } from './WorkoutModel';

export class ClassModel {
    constructor(classData) {
        const personalTrainer = this.getPersonalTrainer(classData);
        const gym = this.getGym(classData);
        const workout = this.getWorkout(classData);

        this._class = {
            id: classData.id,
            name: classData.name,
            totalClassSeat: classData.total_class_seat,
            description: classData.description,
            type: classData.type,
            start: classData.start,
            end: classData.end,
            price: classData.price,
            createdAt: classData.created_at,
            spacesLeft: classData.spaces_left,
            recurring: classData.recurring,
            recurringEnd: classData.recurring_end,
            freeCancellationDate: classData.free_cancel_date,
            roomNumber: classData.room_number,
            seriesId: classData.series_id,
            isBooked: classData.is_booked,
            memberId: classData.memberId,
            smallImage: classData.image ? classData.image.data.small_url : null,
            mediumImage: classData.image ? classData.image.data.medium_url : null,
            originalImage: classData.image ? classData.image.data.original_url : null,
            personalTrainer,
            gym,
            workout,
        };
    }

    get __class() {
        return this._class;
    }

    getPersonalTrainer(classData) {
        let personalTrainer;

        if (classData.pt) {
            const personalTrainerUserModel = new UserModel(classData.pt.data);
            personalTrainer = { ...personalTrainerUserModel._user };
        }

        return personalTrainer;
    }

    getGym(classData) {
        let gym;

        if (classData.gym) {
            const gymUserModel = new UserModel(classData.gym.data);
            gym = { ...gymUserModel._user };
        }

        return gym;
    }

    getWorkout(classData) {
        let workout;

        if (classData.workout) {
            const workoutModel = new WorkoutModel(classData.workout.data);
            workout = { ...workoutModel._workout };
        }

        return workout;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/ClassModel.js